<script>
import './style.less';
function play() {
  console.log('【恢复播放视频】');
  window.$player.play();
}
export default {
  name: 'SpeakSheet',
  data() {
    return {
      speak: '',
      timer: null
    };
  },
  model: {
    prop: 'show',
    event: 'showSpeak'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    words: {
      type: Array,
      default: () => {
        return [];
      }
    },
    showWord: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    calcShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('showSpeak', val);
      }
    }
  },
  watch: {
    show: {
      handler: function(val) {
        if (val === false) {
          this.speak = '';
          this.timer = setTimeout(() => {
            window.$player.off('pause', play);
            console.log('【3秒后移除暂停事件监听】');
          }, 3000);
        } else {
          if (window.$player) {
            window.$player.on('pause', play);
            console.log('【监听暂停事件】');
          }
          this.$nextTick(() => {
            this.calcShow && this.$refs.speak.focus();
          });
        }
      }
    }
  },
  mounted() {},
  methods: {
    showSpeak() {
      this.$emit('showSepak', true);
    },
    send() {
      this.speak.length && this.$emit('click', this.speak);
    },
    add(val) {
      this.speak = `${this.speak}${val}`;
    },
    renderWord() {
      const words = this.words.map((e) => {
        return (
          <span
            onclick={() => {
              this.add(e.commonWord);
            }}
          >
            <i class="iconfont icon-xing"></i>
            {e.commonWord}
          </span>
        );
      });
      return this.showWord ? <div class="common-words"> {words}</div> : null;
    }
  },
  render() {
    const renderField = <van-field v-model={this.speak} autosize type="textarea" maxlength={120} placeholder="优质评论将优先展示" ref="speak" />;
    const props = {
      round: false
    };
    const innerProps = {
      disabled: true
    };
    const renderSheet = (
      <van-action-sheet class="speak-sheet" {...{ props }} v-model={this.calcShow}>
        {this.renderWord()}
        <div class="speak-box">
          <div class="speak-left">{renderField}</div>
          <van-button class="release-but" type="default" onclick={this.send} {...{ innerProps }}>
            发布
          </van-button>
        </div>
      </van-action-sheet>
    );
    return renderSheet;
  }
};
</script>
